import {
  BrandPurchaserLink,
  type IBrandPurchaserLink,
} from "../purchaser/BrandPurchaserLink";

export interface IBrandPurchaserRow {
  purchaserId: number;
  purchaserKey: string;
  purchaserName: string;
  purchaserIsActive: boolean;
  brandPurchaser: IBrandPurchaserLink;
}

export class BrandPurchaser {
  private readonly _purchaserId: number;
  private readonly _purchaserKey: string;
  private readonly _purchaserName: string;
  private readonly _purchaserIsActive: boolean;
  private readonly _brandPurchaser: BrandPurchaserLink;

  constructor(props: IBrandPurchaserRow) {
    this._purchaserId = props.purchaserId;
    this._purchaserKey = props.purchaserKey;
    this._purchaserName = props.purchaserName;
    this._purchaserIsActive = props.purchaserIsActive;
    this._brandPurchaser = BrandPurchaserLink.from(props.brandPurchaser);
  }

  get purchaserId(): number {
    return this._purchaserId;
  }

  get purchaserKey(): string {
    return this._purchaserKey;
  }

  get purchaserName(): string {
    return this._purchaserName;
  }

  get purchaserIsActive(): boolean {
    return this._purchaserIsActive;
  }

  get brandPurchaser(): BrandPurchaserLink {
    return this._brandPurchaser;
  }

  static from(props: IBrandPurchaserRow): BrandPurchaser {
    return new BrandPurchaser(props);
  }
}
